import env from 'config/env';
import Icon from './icon';
import { POST_MESSAGE_TYPE } from 'app/utilities/post-message-type';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * Label attached to the content block selected in the CMS live page builder.
 * Clicking it asks the builder to open that block for editing.
 *
 * @param {object} props
 * @return {object} JSX
 */
const ActiveOverlay = ({ type, activeIndex }) => {
    const onClick = (e) => {
        // The block underneath toggles its selection when clicked, which
        // pressing edit should not do
        e.stopPropagation();

        // Send a message to the parent window/iframe
        window.parent.postMessage({
            type: POST_MESSAGE_TYPE.EDIT_CONTENT_BLOCK_CLICKED,
            payload: { type, activeIndex }
        }, env.CMS_DOMAIN);
    };

    const onKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick(e);
        }
    };

    return (
        <div
            className="active-overlay"
            onClick={onClick}
            onKeyDown={onKeyDown}
            role="button"
            tabIndex={0}
        >
            <span className="active-overlay-title">
                {type}
            </span>
            <Icon className="icon" name="edit" width="20" height="20" />
        </div>
    );
};

ActiveOverlay.propTypes = {
    activeIndex: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired
};

export default ActiveOverlay;
